import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="w-full bg-white py-16 lg:py-24" data-id="element-52" data-mp="1mcoqsk4k87ho">
      <div className="mx-auto max-w-6xl px-5" data-id="element-53" data-mp="1mb3xsyxw8wlx">
        <div className="max-w-2xl" data-id="element-54" data-mp="1r3n9trgxnjom">
          <h2 className="font-display text-3xl uppercase leading-tight text-forest-800 sm:text-4xl" data-id="element-55" data-mp="1r4gi4wvjih8v">
            Here&apos;s what changes with Javier&apos;s
          </h2>
          <p className="mt-4 text-lg text-ink-700" data-id="element-56" data-mp="zdsm1z8q4222">
            For years homeowners have been stuck between faceless national haulers and doing it
            themselves. There&apos;s a third option.
          </p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2" data-id="element-57" data-mp="18c47lmuqg9nn">
          {differentiators.map(({
          icon: Icon,
          title,
          body
        }) => <div key={title} className="flex h-full flex-col rounded-lg border border-forest-100 bg-forest-50 p-7" data-id="element-58" data-mp="2jt40okowmsiq">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-forest-800" data-id="element-59" data-mp="2oqmbkgmhfhtd">
                <Icon className="h-6 w-6 text-ember-500" aria-hidden="true" data-id="element-60" data-mp="bnsudmvi7yje" />
              </span>
              <h3 className="mt-5 font-display text-xl uppercase text-forest-800" data-id="element-61" data-mp="7oaa8tbibrhm">{title}</h3>
              <p className="mt-2 text-base leading-relaxed text-ink-700" data-id="element-62" data-mp="2ncpc8z44jcf">{body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}